export const customEn = {};

export const customEs = {};
export const customDa = {};
export const customDe = {};
export const customFi = {};
export const customSv = {};
export const customFr = {};
export const customHu = {};
